import PropTypes from "prop-types";
import {Text as Global_Text} from "../../../components/custom-components/Text";
import {Colors} from "../colors";
import {useContext} from "react";
import AppConfigContext from "../../../contexts/AppConfigContext";

function Text(props: any) {
    const weight = props.weight ?? "400";
    let font = "";
    switch (weight) {
        case 100:
            font = "IRANsans_thin";
            break;
        case 200:
            font = "IRANsans_ultralight";
            break;
        case 300:
            font = "IRANsans_light";
            break;
        default:
        case 400:
            font = "IRANsans";
            break;
        case 500:
            font = "IRANsans_medium";
            break;
        case 600:
            font = "IRANsans_demibold";
            break;
        case 700:
            font = "IRANsans_bold";
            break;
        case 800:
            font = "IRANsans_extrabold";
            break;
        case 900:
            font = "IRANsans_black";
            break;
    }

    return <Global_Text {...props} style={[{
        fontFamily: font,
        fontSize: props.size ?? 14,
        marginBottom: props.mb ?? 0,
        // todo: sync with dynamic theme
        color: props.color ?? Colors.instance(useContext(AppConfigContext).theme, useContext(AppConfigContext).color).get("lowConText")
    }, props.style]}>{props.children}</Global_Text>;
}

Text.propTypes = {
    children: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.number,
    mb: PropTypes.number,
    style: PropTypes.any,
    numberOfLines: PropTypes.any,
    ellipsizeMode: PropTypes.any,
    weight: PropTypes.oneOf([100,200,300,400,500,600,700,800,900]),
    role: PropTypes.any
}

export default Text;